/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBatchAssigneesRealtimeSessionDtoGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivHasAssigneesDtoGen,
  MrfiktivMarkRealtimeSessionsReadDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRealtimeSessionControllerFindAllParamsGen,
  MrfiktivRealtimeSessionControllerGetStatisticsParamsGen,
  MrfiktivRealtimeSessionControllerGetUsageParamsGen,
  MrfiktivRealtimeSessionStatisticsViewModelGen,
  MrfiktivRealtimeSessionUsageViewModelGen,
  MrfiktivRealtimeSessionViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class CallSessionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerFindAll
   * @summary Get all realtime sessions for a partner
   * @request GET:/partner/{partnerId}/call
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRealtimeSessionViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerFindAll = (
    { partnerId, ...query }: MrfiktivRealtimeSessionControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivRealtimeSessionViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/call`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerGetUsage
   * @summary (Call - READ) Get voice-AI-call usage totals for a partner
   * @request GET:/partner/{partnerId}/call/usage
   * @secure
   * @response `200` `MrfiktivRealtimeSessionUsageViewModelGen` Usage totals for the partner in the requested period
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerGetUsage = (
    { partnerId, ...query }: MrfiktivRealtimeSessionControllerGetUsageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRealtimeSessionUsageViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerGetStatistics
   * @summary (Call - READ) Get voice-AI-call KPIs for a partner
   * @request GET:/partner/{partnerId}/call/statistics
   * @secure
   * @response `200` `MrfiktivRealtimeSessionStatisticsViewModelGen` KPIs for the partner in the requested period
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerGetStatistics = (
    { partnerId, ...query }: MrfiktivRealtimeSessionControllerGetStatisticsParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRealtimeSessionStatisticsViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/statistics`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerAddBatchAssignees
   * @summary (Call - UPDATE) Batch add assignees to calls
   * @request PATCH:/partner/{partnerId}/call/batch/assignees/add
   * @secure
   * @response `200` `(MrfiktivRealtimeSessionViewModelGen)[]` The updated calls
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerAddBatchAssignees = (
    partnerId: string,
    data: MrfiktivBatchAssigneesRealtimeSessionDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen[], MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/batch/assignees/add`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerMarkManyRead
   * @summary (Call - UPDATE) Mark multiple calls as read
   * @request POST:/partner/{partnerId}/call/batch/read
   * @secure
   * @response `200` `void` Number of calls updated
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerMarkManyRead = (
    partnerId: string,
    data: MrfiktivMarkRealtimeSessionsReadDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<void, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/batch/read`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerFindOne
   * @summary Get a realtime session by ID
   * @request GET:/partner/{partnerId}/call/{sessionId}
   * @secure
   * @response `200` `MrfiktivRealtimeSessionViewModelGen` The realtime session with call tracking data
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerFindOne = (partnerId: string, sessionId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/${sessionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerSetAssignees
   * @summary (Call - UPDATE) Set the assignees of a call
   * @request PATCH:/partner/{partnerId}/call/{sessionId}/assignees
   * @secure
   * @response `200` `MrfiktivRealtimeSessionViewModelGen` The updated call
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerSetAssignees = (
    partnerId: string,
    sessionId: string,
    data: MrfiktivHasAssigneesDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/${sessionId}/assignees`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerClose
   * @summary (Call - UPDATE) Close/archive a call
   * @request PATCH:/partner/{partnerId}/call/{sessionId}/close
   * @secure
   * @response `200` `MrfiktivRealtimeSessionViewModelGen` The closed call
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerClose = (partnerId: string, sessionId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/${sessionId}/close`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerReopen
   * @summary (Call - UPDATE) Reopen a closed call
   * @request PATCH:/partner/{partnerId}/call/{sessionId}/reopen
   * @secure
   * @response `200` `MrfiktivRealtimeSessionViewModelGen` The reopened call
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerReopen = (partnerId: string, sessionId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/${sessionId}/reopen`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
}
